import React from 'react'

import { Building, FileEarmark, FileEarmarkBarGraph, FileEarmarkImage, FiletypeCsv, FiletypeJson, FiletypeTxt, FileZip } from 'react-bootstrap-icons'

export const getFileIcon = (type?: string): React.ReactNode => {
  const size = 12

  switch (type?.toLowerCase()) {
    case 'txt':
    case 'log':
    case 'idf':
    case 'osm':
    case 'rad':
    case 'mat':
    case 'err':
    case 'eio':
    case 'rdd':
    case 'mdd':
    case 'eso':
    case 'mtd':
    case 'shd':
    case 'audit':
    case 'bnd':
    case 'blk':
      return <FiletypeTxt size={size} />
    case 'xml':
    case 'ddy':
    case 'epw':
    case 'rain':
    case 'stat':
    case 'clm':
    case 'wea':
    case 'ill':
    case 'da':
    case 'cda':
    case 'udi':
    case 'res':
      return <FileEarmarkBarGraph size={size} style={{ fill: '#A61E4E' }} />
    case 'csv':
      return <FiletypeCsv size={size} style={{ fill: '#2B8A3E' }} />
    case 'json':
    case 'osw':
      return <FiletypeJson size={size} style={{ fill: '#1D64AB' }} />
    case 'hbjson':
      return <Building size={size} style={{ fill: '#F5B34C' }} />
    case '3dm':
    case 'vtkjs':
    case 'vtp':
      return <Building size={size} style={{ fill: '#F08C00' }} />
    case 'jpg':
    case 'png':
    case 'svg':
    case 'hdr':
      return <FileEarmarkImage size={size} style={{ fill: '#862E9C' }} />
    case 'zip':
      return <FileZip size={size} />
    default:
      return <FileEarmark size={size} />
  }
}
